import React from "react"
import { useSelector } from "react-redux"
import { getClockFormat } from "reduxSlices/currentSettingsSlice"
import { orgLocalDateTimeByClockFormat } from "utils/dateHelpers"
import { conversationMessageShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"
import { ProfileIcon } from "shared/icons"

const ConversationMessageListItem = ({ message }) => {
  const clockFormat = useSelector(getClockFormat)

  const { author, createdAt, text } = message
  const { fullName: authorFullName } = author

  return (
    <ItemRow
      className="dark"
      itemRowHeaderContent={(
        <div className="flex flex-col items-start sm:flex-row sm:items-center justify-between w-full text-sm">
          <div className="flex flex-row items-center gap-2 grow min-w-0">
            <ProfileIcon className="hidden sm:flex" user={author} />
            <span className="grow font-semibold truncate">{authorFullName}</span>
          </div>
          <span className="shrink-0 text-dark text-xs sm:text-sm">
            {orgLocalDateTimeByClockFormat(createdAt, clockFormat)}
          </span>
        </div>
      )}
      itemRowBody={(
        <p className="whitespace-pre-wrap break-anywhere">
          {text}
        </p>
      )}
    />
  )
}

ConversationMessageListItem.propTypes = {
  message: conversationMessageShape.isRequired,
}

export default ConversationMessageListItem
